'use strict';

let formValidation = require('../components/formValidation');

module.exports = function () {
  $('.trackorder').on('bouncerFormValid', function (e) {
    let form = $(this);
    e.preventDefault();
    let url = form.attr('action');
    window.$.spinner().start();
    $.ajax({
      url: url,
      type: 'post',
      dataType: 'json',
      data: form.serialize(),
      success: function (data) {
        window.$.spinner().stop();
        if (!data.success) {
          formValidation(form, data);
        } else {
          location.href = data.redirectUrl;
        }
      },
      error: function (data) {
        console.log(data);
      },
    });
  });
};
